import { render } from "./editPhoneNumber.vue?vue&type=template&id=f7bec476&ts=true"
import script from "./editPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./editPhoneNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__